/* Créée par Incipit Studio — tri Shopify de la collection courante */
if (!customElements.get('kaarz-collection')) {
  customElements.define('kaarz-collection', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.mode !== 'best-selling' || this.dataset.sort === 'best-selling') return;
      this.controller=new AbortController(); this.sort();
    }
    disconnectedCallback(){this.controller?.abort();clearTimeout(this.timeout);}
    async sort(){
      const region=this.querySelector('[data-collection-region]');
      const notice=this.querySelector('[data-sort-notice]');
      const url=new URL(location.href);url.searchParams.set('sort_by','best-selling');url.searchParams.delete('page');
      const request=new URL(url);request.searchParams.set('section_id',this.dataset.sectionId);
      region.inert=true;region.setAttribute('aria-busy','true');this.classList.add('is-sorting');notice.hidden=false;
      this.timeout=setTimeout(()=>this.controller.abort(),12000);
      try {
        const response=await fetch(request,{signal:this.controller.signal,credentials:'same-origin'});
        if(!response.ok)throw new Error('response');
        const html=new DOMParser().parseFromString(await response.text(),'text/html');
        const source=html.querySelector('kaarz-collection');
        if(source?.dataset.sort!=='best-selling')throw new Error('sort');
        const replacement=source.querySelector('[data-collection-region]');
        if(!replacement)throw new Error('region');
        replacement.querySelectorAll('.kcl-pagination a').forEach(link=>{
          const target=new URL(link.getAttribute('href'),url);
          target.searchParams.delete('section_id');
          link.href=target.href;
        });
        if(!this.isConnected)return;
        region.replaceChildren(...replacement.childNodes);
        this.dataset.sort='best-selling';
        if(!window.Shopify?.designMode)history.replaceState(history.state,'',url);
        notice.hidden=true;
      } catch(error) {
        if(!this.isConnected)return;
        notice.replaceChildren(document.createTextNode('Le tri par meilleures ventes n’a pas pu être chargé. '));
        const link=document.createElement('a');link.href=url.href;link.textContent='Réessayer';notice.append(link);
      } finally {
        clearTimeout(this.timeout);region.inert=false;region.removeAttribute('aria-busy');this.classList.remove('is-sorting');
      }
    }
  });
}
